<template>
    <footer class="bg-gray-900 text-white py-8 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto text-center">
        <div class="flex justify-center space-x-6 mb-4">
          <a href="#" class="text-gray-400 hover:text-green-400 transition duration-300">
            <i class="fab fa-facebook-f"></i>
          </a>
          <!-- <a href="#" class="text-gray-400 hover:text-green-400 transition duration-300">
            <i class="fab fa-twitter"></i>
          </a> -->
          <a href="#" class="text-gray-400 hover:text-green-400 transition duration-300">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.instagram.com/masterbit.eu" class="text-gray-400 hover:text-green-400 transition duration-300">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
        <p class="text-sm">© Master Projekt E.M. d.o.o. | OIB: 46875550443</p>
        <p class="text-sm">Master Projekt SH.P.K.</p>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Import Font Awesome */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

/* Cyber green glow effect for interactive elements */
button.bg-green-500:hover, 
button.bg-green-600:hover {
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.7);
}

/* Custom focus styles */
input:focus, textarea:focus {
  box-shadow: 0 0 0 3px rgba(74, 222, 128, 0.3);
  border-color: #10B981;
}
</style>
